// if (!customElements.get("product-form")) {
//   customElements.define(
//     "product-form",
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();
//         this.form = this.querySelector("form");
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
//         this.cart =
//           document.querySelector("cart-notification") ||
//           document.querySelector("cart-drawer");
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector("span");
//         if (document.querySelector("cart-drawer"))
//           this.submitButton.setAttribute("aria-haspopup", "dialog");
//         this.hideErrors = this.dataset.hideErrors === "true";
//       }

//       onSubmitHandler(evt) { 
//         evt.preventDefault();
//         // // itg code 
//         // addAddonProductsItg();

//         if (this.submitButton.getAttribute("aria-disabled") === "true") return;
//         this.handleErrorMessage();
//         this.submitButton.setAttribute("aria-disabled", true);
//         this.submitButton.classList.add("loading");
//         this.querySelector(".loading__spinner").classList.remove("hidden");
//         const config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];
//         const formData = new FormData(this.form);
//         const checkedInputs = document.querySelectorAll('.container_check input[type="checkbox"]:checked');
//          if (checkedInputs.length > 0) {
//           // Append checked items to FormData
//           checkedInputs.forEach((input, index) => {
            
//               const itemId = input.value; // assuming checkbox value is the item id
//               const quantityInput = 1;
//               const quantity = quantityInput ? quantityInput : 1;
//               formData.append(`items[${index + 1}][id]`, itemId);
//               formData.append(`items[${index + 1}][quantity]`, quantity);
//           });
//          }

//         if (this.cart) {
//           formData.append(
//             "sections",
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append("sections_url", window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;
//         let addedItemData = null;
//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             addedItemData = response;
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage =
//                 this.submitButton.querySelector(".sold-out-message");
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute("aria-disabled", true);
//               this.submitButtonText.classList.add("hidden");
//               soldOutMessage.classList.remove("hidden");
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }
//             // itg code start 
//             this.submitButton.classList.remove("loading");
//             this.submitButton.removeAttribute("aria-disabled");
//             this.querySelector(".loading__spinner").classList.add("hidden");
//             // itg code end 

//             const startMarker = CartPerformance.createStartingMarker(
//               "add:wait-for-subscribers"
//             );
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: "product-form",
//                 productVariantId: formData.get("id"),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker(
//                   "add:wait-for-subscribers",
//                   startMarker
//                 );
//               });
//             this.error = false;
//             const quickAddModal = this.closest("quick-add-modal");
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 "modalClosed",
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure(
//                       "add:paint-updated-sections",
//                       () => {
//                         this.cart.renderContents(response);
//                       }
//                     );
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//             this.addFailed = true;
//           })
//           .finally(() => {
//             this.submitButton.classList.remove("loading");
//             if (this.cart && this.cart.classList.contains("is-empty"))
//               this.cart.classList.remove("is-empty");
//             if (!this.error)
//               this.submitButton.removeAttribute("aria-disabled");
//             this.querySelector(".loading__spinner").classList.add("hidden");
//             CartPerformance.measureFromEvent("add:user-action", evt);

//             if (this.addFailed || this.error) {
//               this.addFailed = false;
//               return;
//             }

//             const targetVendors = ["LogOX","TimberOX","GearHaul","Hud-Son","One Tree Planted","Order Protection","Printful","Printify","Route","SawHaul","Swisher Inc","BigToolRack","Granberg","LT wright knives","Granberg International"];
//             const r = addedItemData;
//             const addedVendor = (r && typeof r === "object" && r.vendor) ? r.vendor : null;
//             const addedTitle = (r && typeof r === "object" && (r.product_title || r.title)) || "";
//             const addedHandle = (r && typeof r === "object" && r.handle) || "";

//             const vendorMatches = addedVendor && targetVendors.includes(addedVendor);
//             const titleHandleMatches = targetVendors.some((v) => {
//               const lower = v.toLowerCase().replace(/\s+/g, "");
//               const t = (addedTitle + " " + addedHandle).toLowerCase().replace(/\s+/g, "");
//               return t.includes(lower);
//             });
//             const isRelevantVendor = vendorMatches || titleHandleMatches;

//             const accessoriesEl = document.getElementById("compatible_accessories");
//             const checkedAccessories = accessoriesEl ? $('.modal-choices input[type="checkbox"]:checked').length : 0;

//             if (!isRelevantVendor && checkedAccessories === 0) {
//               return;
//             }

//             if (ProductForm._giftLogicRunning) {
//               return;
//             }
//             ProductForm._giftLogicRunning = true;

//             let chain = Promise.resolve();
//             if (accessoriesEl && checkedAccessories > 0) {
//               chain = chain.then(() => this.addAddonProducts());
//             }
//             if (isRelevantVendor && typeof this.handleLogOXGiftLogic === "function") {
//               chain = chain.then(() => this.handleLogOXGiftLogic());
//             }
//             chain
//               .catch((err) => { console.error("Background cart update failed:", err); })
//               .finally(() => { ProductForm._giftLogicRunning = false; });
//           });
//       }

// addAddonProducts() {
//   const upsellHtml = `<div class="upsell-message">Accessories Adding... </div>`;
//   $(".drawer__header").append(upsellHtml);

//   const variantIds = $('.modal-choices input[type="checkbox"]:checked')
//     .map(function () {
//       return parseInt($(this).val(), 10); // Ensure ID is number
//     })
//     .get();

//   const items = variantIds.map(id => ({
//     id,
//     quantity: 1
//   }));

//   return $.ajax({
//     type: "POST",
//     url: window.Shopify.routes.root + 'cart/add.js',
//     data: JSON.stringify({ items }),
//     contentType: "application/json",
//   })
//     .then((response) => {
//       console.log("Cart updated", response);
//       return response;
//     })
//     .catch((error) => {
//       console.error("Failed to update cart:", error);
//       throw error;
//     });
// }


// handleLogOXGiftLogic() {
//   return fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" })
//     .then((res) => (res.status === 429 ? null : res.json()))
//     .then((cartData) => {
//       if (!cartData || !Array.isArray(cartData.items)) {
//         return Promise.resolve("Rate limited or invalid cart data");
//       }

//       const items = cartData.items;
//       let TotalBrandPrice = 0;

//       const targetVendors = [
//        "TimberOX","GearHaul", "Hud-Son", "One Tree Planted", "Order Protection", "Printful",
//         "Printify", "Route", "SawHaul", "Swisher Inc", "BigToolRack", "Granberg",
//         "LT wright knives", "Granberg International"
//       ];

//       const hasTargetVendorItem = items.some(item => targetVendors.includes(item.vendor));

//       if (!hasTargetVendorItem) {
//         const BrandItems = items.filter(item => item.vendor === "LogOX");

//         if (BrandItems.length > 0) {
//           BrandItems.forEach(item => {
//             TotalBrandPrice += item.quantity * item.price;
//           });

//           TotalBrandPrice /= 100;
//           console.log("Total price of LogOX items:", TotalBrandPrice);

//           if (TotalBrandPrice > 499.99) {
//             return this.updateCarts(items, TotalBrandPrice, "sticker", "hat", "mug2", "yes", {
//               41499771568214: 1,
//               41499773239382: 1,
//               41607435190358: 1
//             });
//           } else if (TotalBrandPrice > 249.99) {
//             return this.updateCarts(items, TotalBrandPrice, "sticker", "hat", "mug2", "yes", {
//               41499771568214: 1,
//               41499773239382: 1,
//               41607435190358: 0
//             });
//           } else {
//             return this.updateCarts(items, TotalBrandPrice, "sticker", "hat", "mug2", "yes", {
//               41499771568214: 0,
//               41499773239382: 0,
//               41607435190358: 0
//             });
//           }
//         }
//       } else {
//         return this.updateCarts(items, 0, "sticker", "hat", "mug2", "no", {
//           41499771568214: 0,
//           41499773239382: 0,
//           41607435190358: 0
//         });
//       }

//       return Promise.resolve("No action needed");
//     })
//     .catch((error) => {
//       console.error("Error in handleLogOXGiftLogic:", error);
//       return Promise.reject(error);
//     });
// }

      
// updateCarts(items, TotalBrandPrice, sticker, hat, mug2, vendor = "yes", updates) {
//   const stickerItem = items.find(item => item.handle === sticker);
//   const hatItem = items.find(item => item.handle === hat);
//   const mug2Item = items.find(item => item.handle === mug2);

//   const updateCart = () => {
//     return fetch(window.Shopify.routes.root + "cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ updates, sections: "cart-drawer", sections_url: window.location.pathname }),
//     })
//       .then(response => {
//         if (response.status === 429) {
//           console.warn("Cart update rate-limited (429).");
//           return null;
//         }
//         return response.json();
//       })
//       .then(data => {
//         if (data && data.sections && data.sections["cart-drawer"]) {
//           const currentCartDrawer = document.querySelector("cart-drawer");
//           const parsed = new DOMParser().parseFromString(data.sections["cart-drawer"], "text/html");
//           const newCartDrawer = parsed.querySelector("cart-drawer");
//           if (newCartDrawer && currentCartDrawer) {
//             const wasActive = currentCartDrawer.classList.contains("active");
//             const wasAnimate = currentCartDrawer.classList.contains("animate");
//             currentCartDrawer.replaceWith(newCartDrawer);
//             if (wasActive) newCartDrawer.classList.add("active");
//             if (wasAnimate) newCartDrawer.classList.add("animate");
//           }
//         }
//         return data;
//       })
//       .catch(error => {
//         console.error("Cart update error:", error);
//         return null;
//       });
//   };

//   if (vendor === "yes") {
//     if (TotalBrandPrice > 499.99) {
//       if (!mug2Item) return updateCart();
//       return Promise.resolve(false);
//     } else if (TotalBrandPrice >= 250) {
//       if (!stickerItem || !hatItem || mug2Item) return updateCart();
//       return Promise.resolve(false);
//     } else {
//       $(".confirmation_messages").css("display", "flex");
//       $("p.shipping-texts").show();

//       if (stickerItem || hatItem || mug2Item) return updateCart();
//       return Promise.resolve(false);
//     }
//   } else if (vendor === "no") {
//     return updateCart();
//   }

//   return Promise.resolve(false);
// }


//       refreshCartDrawer(TotalBrandPrice) {
//         fetch("/?section_id=cart-drawer")
//           .then(function (res) {
//             return res.text();
//           })
//           .then(function (text) {
//             const html = new DOMParser().parseFromString(text, "text/html");
//             const newCartDrawer = html.querySelector("cart-drawer");
//             const currentCartDrawer = document.querySelector("cart-drawer");

//             if (newCartDrawer && currentCartDrawer) {
//               currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
//             }
//           })
//           .catch(function (e) {
//             console.error("Failed to refresh cart drawer:", e);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message"
//           );

//         this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute("disabled", "disabled");
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute("disabled");
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector("[name=id]");
//       }
//     }
//   );
// }


// // // itg code start 

// // function addAddonProductsItg() { 
// //     var checkedInputs = document.querySelectorAll('input[data-variant]:checked');
  
// //     var cartForms = document.querySelectorAll('form[action="/cart/add"].form');

// //     cartForms.forEach((cartForm) => {
        
// //         var hiddenInputs = cartForm.querySelectorAll('.add-on-hidden');
// //         hiddenInputs.forEach((input) => {
// //             input.remove();
// //             console.log('Old hidden input removed');
// //         });

// //         if (checkedInputs.length > 0) {
           
// //             checkedInputs.forEach((checkedInput, index) => {
// //                 var variantId = checkedInput.getAttribute('data-variant');
// //                 if(variantId){
// //                   cartForm.insertAdjacentHTML(
// //                       'beforeend',
// //                       `<input type="hidden"
// //                           name="items[][id]"
// //                           value="${variantId}"
// //                           class="add-on-hidden">`
// //                   );
// //                 }
// //             });
// //         } else {
// //             console.log('No items selected - No hidden inputs to append');
// //         }
// //     });
// // }
// // itg code end 

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) { 
        evt.preventDefault();
        // // itg code 
        // addAddonProductsItg();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        const checkedInputs = document.querySelectorAll('.container_check input[type="checkbox"]:checked');
         if (checkedInputs.length > 0) {
          // Append checked items to FormData
          checkedInputs.forEach((input, index) => {
            
              const itemId = input.value; // assuming checkbox value is the item id
              const quantityInput = 1;
              const quantity = quantityInput ? quantityInput : 1;
              formData.append(`items[${index + 1}][id]`, itemId);
              formData.append(`items[${index + 1}][quantity]`, quantity);
          });
         }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        let addedItemData = null;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            addedItemData = response;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            // itg code start 
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            // itg code end 

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.addFailed = true;
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error)
              this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            CartPerformance.measureFromEvent("add:user-action", evt);

            // ============================================================
            // GIFT LOGIC DISABLED — will be re-implemented properly during
            // cart drawer redesign. Disabled to prevent 429 rate limits
            // from Shopify/Cloudflare on heavy cart activity.
            // Shipping progress bar still works via Liquid (server-side).
            // ============================================================
            return;
          });
      }

addAddonProducts() {
  const upsellHtml = `<div class="upsell-message">Accessories Adding... </div>`;
  $(".drawer__header").append(upsellHtml);

  const variantIds = $('.modal-choices input[type="checkbox"]:checked')
    .map(function () {
      return parseInt($(this).val(), 10); // Ensure ID is number
    })
    .get();

  const items = variantIds.map(id => ({
    id,
    quantity: 1
  }));

  return $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + 'cart/add.js',
    data: JSON.stringify({ items }),
    contentType: "application/json",
  })
    .then((response) => {
      console.log("Cart updated", response);
      return response;
    })
    .catch((error) => {
      console.error("Failed to update cart:", error);
      throw error;
    });
}


handleLogOXGiftLogic() {
  return fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" })
    .then((res) => (res.status === 429 ? null : res.json()))
    .then((cartData) => {
      if (!cartData || !Array.isArray(cartData.items)) {
        return Promise.resolve("Rate limited or invalid cart data");
      }

      const items = cartData.items;
      let TotalBrandPrice = 0;

      const targetVendors = [
       "TimberOX","GearHaul", "Hud-Son", "One Tree Planted", "Order Protection", "Printful",
        "Printify", "Route", "SawHaul", "Swisher Inc", "BigToolRack", "Granberg",
        "LT wright knives", "Granberg International"
      ];

      const hasTargetVendorItem = items.some(item => targetVendors.includes(item.vendor));

      if (!hasTargetVendorItem) {
        const BrandItems = items.filter(item => item.vendor === "LogOX");

        if (BrandItems.length > 0) {
          BrandItems.forEach(item => {
            TotalBrandPrice += item.quantity * item.price;
          });

          TotalBrandPrice /= 100;
          console.log("Total price of LogOX items:", TotalBrandPrice);

          if (TotalBrandPrice > 499.99) {
            return this.updateCarts(items, TotalBrandPrice, "sticker", "hat", "mug2", "yes", {
              41499771568214: 1,
              41499773239382: 1,
              41607435190358: 1
            });
          } else if (TotalBrandPrice > 249.99) {
            return this.updateCarts(items, TotalBrandPrice, "sticker", "hat", "mug2", "yes", {
              41499771568214: 1,
              41499773239382: 1,
              41607435190358: 0
            });
          } else {
            return this.updateCarts(items, TotalBrandPrice, "sticker", "hat", "mug2", "yes", {
              41499771568214: 0,
              41499773239382: 0,
              41607435190358: 0
            });
          }
        }
      } else {
        return this.updateCarts(items, 0, "sticker", "hat", "mug2", "no", {
          41499771568214: 0,
          41499773239382: 0,
          41607435190358: 0
        });
      }

      return Promise.resolve("No action needed");
    })
    .catch((error) => {
      console.error("Error in handleLogOXGiftLogic:", error);
      return Promise.reject(error);
    });
}

      
updateCarts(items, TotalBrandPrice, sticker, hat, mug2, vendor = "yes", updates) {
  const stickerItem = items.find(item => item.handle === sticker);
  const hatItem = items.find(item => item.handle === hat);
  const mug2Item = items.find(item => item.handle === mug2);

  const updateCart = () => {
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates, sections: "cart-drawer", sections_url: window.location.pathname }),
    })
      .then(response => {
        if (response.status === 429) {
          console.warn("Cart update rate-limited (429).");
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (data && data.sections && data.sections["cart-drawer"]) {
          const currentCartDrawer = document.querySelector("cart-drawer");
          const parsed = new DOMParser().parseFromString(data.sections["cart-drawer"], "text/html");
          const newCartDrawer = parsed.querySelector("cart-drawer");
          if (newCartDrawer && currentCartDrawer) {
            const wasActive = currentCartDrawer.classList.contains("active");
            const wasAnimate = currentCartDrawer.classList.contains("animate");
            currentCartDrawer.replaceWith(newCartDrawer);
            if (wasActive) newCartDrawer.classList.add("active");
            if (wasAnimate) newCartDrawer.classList.add("animate");
          }
        }
        return data;
      })
      .catch(error => {
        console.error("Cart update error:", error);
        return null;
      });
  };

  if (vendor === "yes") {
    if (TotalBrandPrice > 499.99) {
      if (!mug2Item) return updateCart();
      return Promise.resolve(false);
    } else if (TotalBrandPrice >= 250) {
      if (!stickerItem || !hatItem || mug2Item) return updateCart();
      return Promise.resolve(false);
    } else {
      $(".confirmation_messages").css("display", "flex");
      $("p.shipping-texts").show();

      if (stickerItem || hatItem || mug2Item) return updateCart();
      return Promise.resolve(false);
    }
  } else if (vendor === "no") {
    return updateCart();
  }

  return Promise.resolve(false);
}


      refreshCartDrawer(TotalBrandPrice) {
        fetch("/?section_id=cart-drawer")
          .then(function (res) {
            return res.text();
          })
          .then(function (text) {
            const html = new DOMParser().parseFromString(text, "text/html");
            const newCartDrawer = html.querySelector("cart-drawer");
            const currentCartDrawer = document.querySelector("cart-drawer");

            if (newCartDrawer && currentCartDrawer) {
              const wasActive = currentCartDrawer.classList.contains("active");
              const wasAnimate = currentCartDrawer.classList.contains("animate");
              currentCartDrawer.replaceWith(newCartDrawer);
              if (wasActive) newCartDrawer.classList.add("active");
              if (wasAnimate) newCartDrawer.classList.add("animate");
            }
          })
          .catch(function (e) {
            console.error("Failed to refresh cart drawer:", e);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}


// // itg code start 

// function addAddonProductsItg() { 
//     var checkedInputs = document.querySelectorAll('input[data-variant]:checked');
  
//     var cartForms = document.querySelectorAll('form[action="/cart/add"].form');

//     cartForms.forEach((cartForm) => {
        
//         var hiddenInputs = cartForm.querySelectorAll('.add-on-hidden');
//         hiddenInputs.forEach((input) => {
//             input.remove();
//             console.log('Old hidden input removed');
//         });

//         if (checkedInputs.length > 0) {
           
//             checkedInputs.forEach((checkedInput, index) => {
//                 var variantId = checkedInput.getAttribute('data-variant');
//                 if(variantId){
//                   cartForm.insertAdjacentHTML(
//                       'beforeend',
//                       `<input type="hidden"
//                           name="items[][id]"
//                           value="${variantId}"
//                           class="add-on-hidden">`
//                   );
//                 }
//             });
//         } else {
//             console.log('No items selected - No hidden inputs to append');
//         }
//     });
// }
// itg code end 